"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doHit = doHit;
const board_1 = require("@creature-chess/board");
const direction_1 = require("../../../utils/direction");
const getCooldownForSpeed_1 = require("../../../utils/getCooldownForSpeed");
const getHitDamage_1 = require("../../../utils/getHitDamage");
const getNewAttackerFacingAway_1 = require("../../../utils/getNewAttackerFacingAway");
const getStats_1 = require("../../../utils/getStats");
const inAttackRange_1 = require("../../../utils/inAttackRange");
const ATTACK_TURN_DURATION = 2;
const MOVE_TURN_DURATION = 2;
function doHit(currentTurn, board, pieceRegistry, id, action, { combatStore, creatures, eventLog }) {
    const attacker = pieceRegistry.getPieceById(id);
    const attackerPosition = board.getPiecePosition(id);
    if (!attacker || !attackerPosition) {
        return;
    }
    const target = pieceRegistry.getPieceById(action.payload.targetId);
    const targetPosition = board.getPiecePosition(action.payload.targetId);
    if (!target || !targetPosition) {
        return;
    }
    const attackerStats = (0, getStats_1.getStats)(attacker, creatures);
    const attackRange = (0, getStats_1.getAttackRange)(attacker, creatures);
    const inRange = (0, inAttackRange_1.inAttackRange)((0, board_1.packPosition)(attackerPosition[0], attackerPosition[1]), (0, board_1.packPosition)(targetPosition[0], targetPosition[1]), attackRange);
    if (!inRange) {
        return;
    }
    const attackerCombat = combatStore.getPiece(attacker.id);
    const targetCombat = combatStore.getPiece(target.id);
    const damage = (0, getHitDamage_1.getHitDamage)(attacker, target, creatures);
    const newDefenderHealth = Math.max(targetCombat.currentHealth - damage, 0);
    const attackerDirection = (0, direction_1.getRelativeDirection)((0, board_1.packPosition)(attackerPosition[0], attackerPosition[1]), (0, board_1.packPosition)(targetPosition[0], targetPosition[1]));
    const delta = (0, board_1.getDelta)((0, board_1.packPosition)(attackerPosition[0], attackerPosition[1]), (0, board_1.packPosition)(targetPosition[0], targetPosition[1]));
    const attackerDistance = delta.x + delta.y;
    const attackerFacingAway = (0, getNewAttackerFacingAway_1.getNewAttackerFacingAway)(attackerCombat.facingAway, attackerDirection);
    const canAttackAtTurn = currentTurn +
        ATTACK_TURN_DURATION +
        (0, getCooldownForSpeed_1.getCooldownForSpeed)(attackerStats.speed);
    const canMoveAtTurn = currentTurn + MOVE_TURN_DURATION + (0, getCooldownForSpeed_1.getCooldownForSpeed)(attackerStats.speed);
    combatStore.updatePiecePartial(attacker.id, {
        canAttackAtTurn,
        canMoveAtTurn,
        facingAway: attackerFacingAway,
        battleStats: Object.assign(Object.assign({}, attackerCombat.battleStats), { damageDealt: attackerCombat.battleStats.damageDealt + damage }),
    });
    const canBeAttackedAtTurn = currentTurn + MOVE_TURN_DURATION + 2;
    combatStore.updatePiecePartial(target.id, {
        canBeAttackedAtTurn,
        currentHealth: newDefenderHealth,
        battleStats: Object.assign(Object.assign({}, targetCombat.battleStats), { damageTaken: targetCombat.battleStats.damageTaken + damage }),
    });
    if (eventLog) {
        eventLog.append({
            type: "piece_attack",
            pieceId: attacker.id,
            targetId: target.id,
            ranged: attackRange > 1,
            direction: attackerDirection,
            distance: attackerDistance,
            damage,
        });
        eventLog.append({
            type: "piece_hit",
            pieceId: target.id,
            direction: (0, direction_1.getRelativeDirection)((0, board_1.packPosition)(targetPosition[0], targetPosition[1]), (0, board_1.packPosition)(attackerPosition[0], attackerPosition[1])),
            damage,
        });
    }
}
